import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { authStorage } from '../utils/authStorage';

interface Props {
  children: JSX.Element;
}

const PublicRoute: React.FC<Props> = ({ children }) => {
  const token = authStorage.getToken();

  if (token) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
